import classNames from 'classnames';
import $ from 'jquery';
import React from 'react';

function _getElementsWithOverflowProperty(element: any): any[] {
  let retvals: any[] = [];
  if (element != null) {
    for (let i = 0; i < element.children.length; i++) {
      let retval: any[] = _getElementsWithOverflowProperty(element.children[i]);
      if (retval.length > 0) {
        retvals = retvals.concat(retval);
      }
    }

    if ($(element).css('text-overflow') === 'ellipsis') {
      retvals.push(element);
    }
  }
  return retvals;
}

function _updateTooltip(tableCell: HTMLDivElement, tooltip?: string): void {
  const targets: any[] = _getElementsWithOverflowProperty(tableCell);
  targets.forEach(target => {
    if (target.offsetWidth < target.scrollWidth) {
      if (tooltip != null) {
        $(target).attr('title', $(target).text() + '\n' + tooltip);
      } else {
        $(target).attr('title', $(target).text());
      }
    } else {
      if (tooltip != null) {
        $(target).attr('title', tooltip);
      } else {
        $(target).removeAttr('title');
      }
    }
  });

}

type Props = {
  content: React.ReactNode,
  rowIndex: number,
  columnIndex: number,
  columnWidth: string,
  alignCenter: boolean,
  alignRight: boolean,
  isReorderingColumn: boolean,
  rowHeight?: number,
  className?: string,
  tooltip?: string
};

class TableCell extends React.PureComponent<Props> {
  private _tableCellContent: HTMLDivElement | null;

  constructor (props: Props) {
    super(props);

    this._tableCellContent = null;
  }

  override componentDidMount (): void {
    if (this._tableCellContent != null) {
      _updateTooltip(this._tableCellContent, this.props.tooltip);
    }
   }

  override componentDidUpdate (prevProps: Readonly<Props>): void {
    if (this._tableCellContent != null) {
      _updateTooltip(this._tableCellContent, this.props.tooltip);
    }
 }

  override render (): React.ReactNode {
    const { rowIndex, columnIndex, content, isReorderingColumn,
      rowHeight, columnWidth, alignCenter, alignRight, className } = this.props;

    let actualContent = content;
    if (isReorderingColumn) {
      actualContent = ' ';
    }

    const tdStyle = rowIndex === 0 ? {width: columnWidth} : undefined;
    return (
      <td key={'drowcol' + rowIndex + '-' + columnIndex}
        style={tdStyle}
        className={classNames('esko_tabledatacell', {esko_tabledatacellnoheight: rowHeight == null}, {esko_tabledatacellaligncenter: alignCenter}, {esko_tabledatacellalignright: alignRight}, className)}
      >
        <div ref={(c) => { this._tableCellContent = c; }} style={{height: (rowHeight != null ? rowHeight + 'px' : undefined)}}>
          {actualContent}
        </div>
      </td>
    );
  }
}

export default TableCell;
